module.exports = __webpack_public_path__ + "img/Apop_Logo_xsm.2300e686.png";